type Props = {
  health?: number | null
}

/** Catalog card battery row — keeps card height even when seller omitted battery data. */
export default function ListingCardBatteryBadge({ health }: Props) {
  const show = health != null && health > 0
  return (
    <span className={`battery${show ? '' : ' battery--catalog-placeholder'}`} aria-hidden={!show}>
      <span className="battery-mark" aria-hidden="true">
        ⏻
      </span>
      {show ? `${health}%` : '0%'}
    </span>
  )
}
